import { render, staticRenderFns } from "./delPopConfirm.vue?vue&type=template&id=12a78b59&"
import script from "./delPopConfirm.vue?vue&type=script&lang=js&"
export * from "./delPopConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports